import { UserFilterApiService } from '@/api/userProfile/UserFilterApiService';
import type { OptionPathsByFilter } from '@/context/FiltersContext/FiltersContext';
import type { FilterState } from '@/types/filter/filterState';

export const SHARE_VIEW_PARAM = 'shareView';

export interface SharedViewPayload {
  globalFilters: FilterState;
  localFilters?: Record<string, Record<string, unknown>>;
  resolvedCountryCodes?: string[];
  /**
   * Option paths the hierarchical filters were selected against. Carried for the
   * same reason as `resolvedCountryCodes`: the recipient's option queries have
   * not run, so without them those filters build a different query.
   */
  optionPaths?: OptionPathsByFilter;
  senderCountryCodes: string[];
}

const buildShareViewUrl = (sharedFilterId: string): string => {
  const url = new URL(window.location.href);
  url.searchParams.set(SHARE_VIEW_PARAM, sharedFilterId);
  return url.toString();
};

export const publishSharedView = async ({
  globalFilters,
  localFilters,
  resolvedCountryCodes,
  optionPaths,
  senderCountryCodes,
}: SharedViewPayload): Promise<string> => {
  const response = await UserFilterApiService.createFilter({
    filterType: 'shared_filter',
    filters: {
      globalFilters,
      ...(localFilters && Object.keys(localFilters).length > 0 && { localFilters }),
      ...(resolvedCountryCodes?.length && { resolvedCountryCodes }),
      ...(optionPaths && Object.keys(optionPaths).length > 0 && { optionPaths }),
      senderCountryCodes,
    },
  });

  return response.data.uniqueFilterId;
};

export const copyShareViewLink = async (sharedFilterId: string): Promise<void> => {
  await navigator.clipboard.writeText(buildShareViewUrl(sharedFilterId));
};
